import { defineComponent as a, resolveComponent as c, createBlock as t, openBlock as o, createSlots as i, withCtx as e, renderSlot as s, resolveDynamicComponent as r } from "vue";
import m from "./Input-KouLK2QK.js";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const l = a({
  components: { TInput: m },
  props: {
    icon: Function,
    startIcon: Function,
    endIcon: Function
  }
});
function I(n, u, f, y, k, $) {
  const p = c("TInput");
  return o(), t(p, null, i({ _: 2 }, [
    n.$slots.start || n.icon || n.startIcon ? {
      name: "start",
      fn: e(() => [
        n.icon || n.startIcon ? (o(), t(r(n.icon || n.startIcon), {
          key: 0,
          class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1"
        })) : s(n.$slots, "start", { key: 1 })
      ]),
      key: "0"
    } : void 0,
    n.$slots.end || n.endIcon ? {
      name: "end",
      fn: e(() => [
        n.endIcon ? (o(), t(r(n.endIcon), {
          key: 0,
          class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1"
        })) : s(n.$slots, "end", { key: 1 })
      ]),
      key: "1"
    } : void 0
  ]), 1024);
}
const F = /* @__PURE__ */ d(l, [["render", I]]);
export {
  F as default
};
//# sourceMappingURL=InputIcon-DYMgHv8r.js.map
